import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './client';

/** Retry once, and never for 4xx: client errors will not fix themselves. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 1;
}

/** A fresh client per app instance (and per request when server-rendering — never share one). */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 60_000, retry: shouldRetry },
      mutations: { retry: false },
    },
  });
}
